import { createFileRoute } from '@tanstack/react-router';
import * as z from 'zod';
import { useLegacyMode } from '@/entities/legacy-mode';
import { DeliveryDashboardPage } from '@/pages/delivery-dashboard';
import { LegacyDashboardPage } from '@/pages/legacy-dashboard';
import { requireAuth } from '../require-auth';

/**
 * `?error` — the old panel's redirect-failure marker: the legacy dashboard
 * toasts a generic error on mount and strips it. Coerced rather than
 * `z.string()` because the router JSON-parses params (`?error=1` arrives as a
 * number), and the old check was just truthiness. Optional + caught so plain
 * navigation is never blocked by it.
 */
const deliveryIndexSearchSchema = z.object({
  error: z.coerce.string().optional().catch(undefined),
});

export const Route = createFileRoute('/delivery/')({
  validateSearch: deliveryIndexSearchSchema,
  // Auth guard — see `require-auth.ts`. Runs before the component mounts,
  // so no query fires without a session.
  beforeLoad: requireAuth,
  component: DeliveryIndexRoute,
});

function DeliveryIndexRoute() {
  const legacy = useLegacyMode();
  return legacy ? <LegacyDashboardPage /> : <DeliveryDashboardPage />;
}
